<div>
  <div class="modal-header">
    <h5 class="modal-title">Add image or URL + caption</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>

  <div class="modal-body">
    <!-- mode switcher -->
    <app-multi-dropdown placeholder="Category" [items]="categoryList" (itemSelected)="onCategoryChange($event)" style="width: 300px;"></app-multi-dropdown>

    <div class="mode-switch my-3">
      <div class="btn-group" role="group" aria-label="Input mode">
        <button type="button" class="btn btn-outline-primary"  [class.active]="mode === 'url'" (click)="mode = 'url'">Image URL</button>
        <button type="button" class="btn btn-outline-primary"  [class.active]="mode === 'file'" (click)="mode = 'file'">Upload image</button>
      </div>
    </div>

    <!-- URL input (no <form>) -->
    <div *ngIf="mode === 'url'" class="mb-3">
      <label class="form-label">Image URL</label>
      <input type="url" class="form-control" placeholder="https://example.com/image.jpg" [(ngModel)]="imageUrl" />
      <div *ngIf="touched && !imageUrl && !fileDataUrl" class="text-danger small mt-1">Provide a URL or upload an image.</div>
    </div>

    <!-- File input -->
    <div *ngIf="mode === 'file'" class="mb-3">
      <label class="form-label">Choose image file</label>
      <input type="file" accept="image/*" (change)="onFileInputChange($event)" />
      <div *ngIf="touched && !fileDataUrl && !imageUrl" class="text-danger small mt-1">Provide a URL or upload an image.</div>
    </div>

    <!-- preview -->
    <div *ngIf="fileDataUrl || imageUrl" class="preview mt-3">
      <label class="form-label">Preview</label>
      <div class="preview-box">
        <img [src]="fileDataUrl || imageUrl" alt="preview" onerror="this.src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='" />
      </div>
    </div>

    <!-- caption (no <form>) -->
    <div class="mb-3 mt-3">
      <label class="form-label">Caption</label>
      <input type="text" class="form-control" placeholder="Write a short caption" [(ngModel)]="caption" />
    </div>

    <div *ngIf="error" class="text-danger small">{{ error }}</div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-primary" (click)="save()">Save</button>
  </div>
</div>
